export const CREATE_NEW_USER_REQUEST = 'USER/CREATE_NEW_USER_REQUEST';
export const CREATE_NEW_USER_SUCCESS = 'USER/CREATE_NEW_USER_SUCCESS';
export const CREATE_NEW_USER_FAILURE = 'USER/CREATE_NEW_USER_FAILURE';

export const FETCH_USER_INFO_REQUEST = 'USER/FETCH_USER_INFO_REQUEST';
export const FETCH_USER_INFO_SUCCESS = 'USER/FETCH_USER_INFO_SUCCESS';
export const FETCH_USER_INFO_FAILURE = 'USER/FETCH_USER_INFO_FAILURE';

export const UDPATE_USER_INFO_REQUEST = 'USER/UDPATE_USER_INFO_REQUEST';
export const UDPATE_USER_INFO_SUCCESS = 'USER/UDPATE_USER_INFO_SUCCESS';
export const UDPATE_USER_INFO_FAILURE = 'USER/UDPATE_USER_INFO_FAILURE';

export const RESET_PASSWORD_REQUEST = 'USER/RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'USER/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'USER/RESET_PASSWORD_FAILURE';

export const VALIDATE_TOKEN_REQUEST = 'USER/VALIDATE_TOKEN_REQUEST';
export const VALIDATE_TOKEN_SUCCESS = 'USER/VALIDATE_TOKEN_SUCCESS';
export const VALIDATE_TOKEN_FAILURE = 'USER/VALIDATE_TOKEN_FAILURE';

export const CHANGE_PASSWORD_REQUEST = 'USER/CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'USER/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'USER/CHANGE_PASSWORD_FAILURE';

export const ACTIVATE_EMAIL_REQUEST = 'USER/ACTIVATE_EMAIL_REQUEST';
export const ACTIVATE_EMAIL_SUCCESS = 'USER/ACTIVATE_EMAIL_SUCCESS';
export const ACTIVATE_EMAIL_FAILURE = 'USER/ACTIVATE_EMAIL_FAILURE';
